export const workgroup = {
    name: 'workgroup',
    params: {
        searchFields: ['name', 'alias', 'operations.name']
    }
};
